import {
  InformationCreationModel,
  InformationDetailModel,
} from "../models/information.model";
import { axiosClient } from "./http-client.service";

export async function getAllCollectedInformation(): Promise<
  InformationDetailModel[]
> {
  const response = await axiosClient.get("/information/all");
  return response.data ?? [];
}

export async function getCollectedInformationById(
  informationId: string
): Promise<InformationDetailModel> {
  const response = await axiosClient.get(`/information/${informationId}`);
  return response.data;
}

export async function createCollectedInformation(
  informationData: InformationCreationModel
): Promise<InformationDetailModel> {
  const response = await axiosClient.post("/information", informationData);
  return response.data;
}

export async function deleteCollectedInformation(
  informationId: string
): Promise<void> {
  await axiosClient.delete(`/information/${informationId}`);
}
